import { listenToDesignThumbnails, type DesignThumbnailItem } from 'packages/services/designsService';
import type { SseSubscribeOptions } from '../useSseSubscribe';

type Params = {
    creativeIds: number[];
    onMessage: SseSubscribeOptions<DesignThumbnailItem[]>['onMessage'];
};

export function sseDesignsThumbnailsOptions({
    creativeIds,
    onMessage,
}: Params): SseSubscribeOptions<DesignThumbnailItem[]> {
    return {
        deps: creativeIds,
        subscribe: (onData, onClose) => listenToDesignThumbnails(creativeIds, onData, onClose),
        onMessage,
    };
}
